import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import ReduxContacts from "../../../../store/actionreducers/apply_medical/contacts";
import {bindActionCreators} from "redux";
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';

class AlertDialog extends React.Component {
    state = {
        open: false,
    };

    handleClose = () => {
        this.props.closeAlertDialog();
    };

    handleAcceptClose = (medicalId) => {
        if (medicalId) {
            this.props.confirmValidateMedical(medicalId);
        } else {
            this.props.closeAlertDialog();
        }
    };

    render() {
        const {alertDialog} = this.props;

        return (
            <div>
                <Dialog
                    open={this.state.open}
                    onClose={this.handleClose}
                    {...(alertDialog && alertDialog.props)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{alertDialog.msg}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">
                            否
                        </Button>
                        <Button color="primary" autoFocus
                                onClick={() => {
                                    this.handleAcceptClose(alertDialog.medicalId)
                                }}>
                            是
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        confirmAddContact: ReduxContacts.ActionCreator.confirmAddContact,
        confirmValidateMedical: ReduxContacts.ActionCreator.confirmValidateMedical,
        closeAlertDialog: ReduxContacts.ActionCreator.closeAlertDialog,
    }, dispatch);
}

function mapStateToProps({applyMedicalsApp}) {
    return {
        alertDialog: applyMedicalsApp.contacts.alertDialog
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AlertDialog));


// WEBPACK FOOTER //
// ./src/main/content/adminMedical/medical/AlertDialog.js